import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import "./index.css"
import * as Sentry from "@sentry/react"

Sentry.init({
	dsn: "https://de540b8f53c943cbac671a4aa2f8b155@o473224.ingest.sentry.io/6236313",
	integrations: [Sentry.browserTracingIntegration()],
  
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
	environment: process.env.REACT_APP_SENTRY_ENVIRONMENT
})

const container = document.getElementById("root")
const root = createRoot(container!)

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
)

